<section class="modal fade" (keypress)="onModalKeydown($event);" [ngClass]="{'modal--big': (modalSize==='big'), 'modal--small': (modalSize==='small')}"
  (keydown)="onModalKeydown($event);" (mouseleave)="onMouseLeave($event)" data-keyboard="false" id="{{modalId}}"
  tabindex="-1" role="dialog" aria-hidden="true" attr.aria-labelledby="modalTitle{{modalId}}">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">

      <!-- Modal header section starts -->
      <div class="modal-header pr-0" id="modal-header-{{modalId}}">
        <div class="row w-100 align-items-start justify-content-between">
          <div class="col pr-0">
            <h2 class="modal-title font-regular" id="modalTitle{{modalId}}">
              <ng-content select="modal-div.title-text" attr.id="{{modalId}}title"></ng-content>
            </h2>

          </div>
          <div class="col-auto pr-0 d-flex align-items-center justify-content-end" id="modal-header-controls-{{modalId}}">
            <ng-content select="modal-div.modal-action"></ng-content>
            <button style="opacity:0" aria-hidden="true" tabindex="-1" id="{{modalId + 'confirmationCustomDialogButton'}}"
              data-toggle="modal" attr.data-target="{{'#'+modalId+'confirmModal'}}" data-backdrop="static"></button>
            <button type="button" class="btn btn-clear btn-highcontrast js-close-btn" aria-label="close modal"
              data-dismiss="modal" id="{{'close'+modalId}}" (click)="onCancel($event)">
              <em class="material-icons-outlined font-4x" aria-hidden="true">close</em>
            </button>
          </div>
        </div>

      </div>
      <!-- Modal header section ends -->

      <!-- Modal body section starts -->
      <div class="modal-body" id="{{'modal-body-'+modalId}}" [ngStyle]="{'min-height': modalId=== 'project-link' ? 'auto' : '250px'}">
        <ng-content select="modal-div.body-content"></ng-content>
        <!-- body content will come between this ng-content -->
      </div>
      <!-- Modal body section ends -->

      <!-- Modal footer section starts -->
      <div class="modal-footer" [ngClass]="{'w-auto': cancelBtnText !== 'Cancel'}" *ngIf="showFooter">
        <button type="button" *ngIf="showCancelBtn" class="btn btn-cancel btn-highcontrast text-underline"
          id="{{'cancel-modal-btn-'+modalId}}" data-dismiss="modal" id="{{'cancel-modal-btn-'+modalId}}"
          (click)="onCancel($event)">{{cancelBtnText}}</button>
        <button *ngIf="showDoneBtn" class="btn btn-primary btn-highcontrast btn-lg float-right" id="{{'done-modal-btn-'+modalId}}"
          type="button" (click)="onCancel($event);" data-dismiss="modal">Done</button>
        <ng-content select="modal-div.footer-buttons"></ng-content>
        <!-- footer buttons will come between this ng-content -->
      </div>
      <!-- Modal footer section ends -->

    </div>
  </div>
</section>
<app-confirmation-modal id="{{modalId+'confirmationModalComponent'}}" #confirmationModalComponent [uniqueId]="modalId" (acceptEvent)="captureConfirmationEvent($event);"
  (declineEvent)="captureConfirmationEvent($event);"></app-confirmation-modal>
